import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

interface CategoryEntryProps {
  counts: Record<string, number>;
}

export default function CategoryEntry({ counts }: CategoryEntryProps) {
  return (
    <div className="grid gap-5 md:grid-cols-2">
      {categories.map((category) => (
        <Link
          key={category.key}
          to={`/category/${category.key}`}
          className="group flex items-start gap-4 rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300 hover:bg-primary-50"
        >
          <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className={`${category.icon} text-2xl`} />
          </span>
          <div className="min-w-0">
            <div className="flex items-center gap-2">
              <h3 className="text-base font-medium text-foreground-950">
                {category.name}
              </h3>
              <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-xs text-secondary-900">
                {counts[category.key] ?? 0} 部
              </span>
            </div>
            <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">
              {category.description}
            </p>
            <span className="mt-3 inline-flex items-center gap-1 text-sm text-accent-600">
              进入分类
              <span className="flex h-4 w-4 items-center justify-center transition-transform group-hover:translate-x-1">
                <i className="ri-arrow-right-line text-base" />
              </span>
            </span>
          </div>
        </Link>
      ))}
    </div>
  );
}